import languageDataMixin from './languageDataMixin';
import { URL_PREFIX, URL_PREFIX_WITHOUT_SLASH } from '~~/common/config/UrlConfig';
import { findCategoryById } from '~~/common/utils/helper';
import otqs from '~~/common/utils/objectToQueryString';
import { useCategoryStore } from '~~/common/stores/category';
import { useCompareStore } from '~~/common/stores/compare';
import { useProductsStore } from '~~/common/stores/products';
import { getBoutiqueUrl, getCategoryUrl, getProductUrl, getShortlistUrl } from '~~/common/composables/useUrls';

export default {

  mixins: [languageDataMixin],
  data () {
    return {
      urlPrefix: URL_PREFIX,
      urlPrefixWithoutSlash: URL_PREFIX_WITHOUT_SLASH,
    };
  },
  computed: {
    getSearchUrl () {
      return (searchText) => {
        const searchTextOrEmpty = searchText.length ? searchText : [''];
        const encodedSearchText = searchTextOrEmpty?.map(currentText => encodeURIComponent(currentText));
        return `${this.localeCodeToUrl}${URL_PREFIX}/search` + otqs({ q: encodedSearchText });
      };
    },
    compareProductsCategoryListUrl () {
      const categoryStore = useCategoryStore();
      const compareStore = useCompareStore();
      const productsStore = useProductsStore();
      // find category slug URL from categories $store by first compared product in list
      const itemCategoryData = findCategoryById(parseInt(compareStore.compareItems[0]?.categoryId), categoryStore.categories?.children);
      // if find data
      if (itemCategoryData) {
        // return URL: use the parent > parentNameArr
        const c = itemCategoryData.parentsNameArr[itemCategoryData.parentsNameArr.length - 2];
        return `${this.localeCodeToUrl}${URL_PREFIX}/${c?.slug}${c?.categoryId ? '.c-' + c.categoryId : ''}`;
      }
      // if not found items in compare list, then find last
      const visitedPagePath = productsStore.visitedPages.find(item => item.type === 'category')?.path;
      if (visitedPagePath) {
        return `${this.localeCodeToUrl}${visitedPagePath}`;
      }
      return false;
    },
  },
  methods: {
    productUrl (variant) {
      return getProductUrl(variant);
    },
    getCategoryUrl (category) {
      return getCategoryUrl(category);
    },
    getBoutiqueUrl (category) {
      return getBoutiqueUrl(category);
    },
    getShortlistUrl () {
      return getShortlistUrl(...arguments);
    },
  },
};
